let listeners: Array<() => void> = [];
let state: { isOpen: boolean; sponsorId?: string; trackTitle?: string } = {
  isOpen: false,
};

function notify() {
  listeners.forEach((l) => l());
}

export function showSponsorAd(data: { sponsorId: string; trackTitle: string }) {
  state = {
    isOpen: true,
    sponsorId: data.sponsorId,
    trackTitle: data.trackTitle,
  };
  notify();
}

export function hideSponsorAd() {
  state = { isOpen: false };
  notify();
}

export function getSponsorAdState() {
  return state;
}

export function subscribeSponsorAd(listener: () => void) {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}
